import React, { useEffect, useState } from "react";
// import AllRequests from "./AllRequests";
// import PendingRequests from "./PendingRequests";
// import AgreementRequests from "./AgreementRequests";
import {
  CustomTabPanel,
  a11yProps,
} from "../../Helpers/CustomTabPanel/CustomTabPanel";
import { StyledBadge } from "../RegistrationRequest/RegistrationRequest";
import InputForm from "../../Components/InputForm/InputForm";
import { LoanDashboardModules } from "../../Helpers/Enums/LoanDashboardModules";
import { Tooltip } from "@mui/material";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { getContext } from "../../Helpers/Context/Context";
import { useLocation, useNavigate } from "react-router-dom";
import DepositeRequest from "./SANReqGrid";
import { IDepositeGridFilters } from "../../Pages/SanjeevaniYojna/Grid/SanjeevaniGrid";
import { SanjeevaniEnum } from "./SanjeevaniEnum/SanjeevaniEnum";
import { ISanjeevaniTab } from "./Interfaces/ISanjeevaniTab";
import DepositeFilters from "../LoanApproval/Filters/DepositeFilters";
import axios from "axios";
import fileDownload from "js-file-download";
import moment from "moment";
import {
  GetSUVYDepositRequestExportToExcel,
  getSNJYDepositRequestExportToExcel,
  GetSNJYWithdrawRequestExportToExcel,
  GetSUVYWithdrawRequestExportToExcel,
} from "../../Helpers/APIEndPoints/EndPoints";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import "./Sanjeevani.css";
import { AppModules } from "../../Helpers/Enums/AppModules";
import { RiFileExcel2Fill } from "react-icons/ri";

const SanjeevaniDashboard = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const context = getContext();
  const [value, setValue] = React.useState(0);
  const [value2, setValue2] = React.useState(0);
  const [searchText, setSearchText] = useState("");
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [currentFilters, setCurrentFilters] =
    useState<IDepositeGridFilters>(null);
  const [dataCount, setDataCount] = useState(0);
  const [currentDataReqObj, setCurrentDataReqObj] = useState(null);
  const [pageSize] = useState(10);
  const [start, setStart] = useState(0);
  let MemberId = context.MemberId;
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  let appModule = props?.appModule || location?.state?.appModule;
  // console.log("appModule1 : " + appModule);
  // const [tab1, setTab1] = useState(0);
  const [tabs, setTabs] = useState<ISanjeevaniTab[]>([
    {
      label: "Deposite Requests",
      value: { ...a11yProps(0) },
      count: 0,
      active: true,
      visible:
        appModule === AppModules.SanjeevaniYojana ||
        appModule === AppModules.SuvidhaYojna,
      id: "Deposite-requests",
      target: SanjeevaniEnum.Deposit,
      module: LoanDashboardModules.All,
    },
    {
      label: "Withdraw Requests",
      value: { ...a11yProps(1) },
      count: 0,
      active: false,
      visible: appModule === AppModules.SanjeevaniYojana,
      id: "Withdraw-requests",
      target: SanjeevaniEnum.Winthdraw,
      module: LoanDashboardModules.All,
    },
  ]);

  // Function to toggle tab visibility based on appModule
  const toggleTabVisibility = (module: AppModules) => {
    setTabs((prevTabs) =>
      prevTabs.map((tab) => ({
        ...tab,
        visible:
          module === AppModules.SanjeevaniYojana ||
          tab.label === "Deposite Requests",
      }))
    );
  };

  // Call toggleTabVisibility whenever appModule changes
  useEffect(() => {
    toggleTabVisibility(appModule);
  }, [appModule]);

  useEffect(() => {
    // Check if appModule is SuvidhaYojna
    if (appModule === AppModules.SuvidhaYojna) {
      setTabs((prevTabs) => {
        return prevTabs.map((tab) => {
          if (
            tab.id === "Deposite-requests" ||
            tab.label === "Deposite Requests"
          ) {
            return { ...tab, visible: true };
          }
          return { ...tab, visible: false };
        });
      });
    } else {
      setTabs((prevTabs) => {
        return prevTabs.map((tab) => {
          return { ...tab, visible: true };
        });
      });
    }
  }, [appModule]);

  const changeTab = (tabNum) => {
    const newTabs = [...tabs];
    newTabs.forEach((nt) => (nt.active = false));
    newTabs[tabNum].active = true;
    setTabs(newTabs);
  };

  const ExportToExcelSSDash = async (url, fileNamePrefix) => {
    const params = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      FromDate: currentFilters?.fromDate || "",
      ToDate: currentFilters?.toDate || "",
      YojnaType: "SanjivaniYojna",
      MemberId: MemberId,
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: url,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
      
        fileDownload(
          response.data,
          `${fileNamePrefix}` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
       
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const handleEvents = (target: SanjeevaniEnum, event: any = null) => {
    switch (target) {
      case SanjeevaniEnum.Deposit:
        changeTab(0);
        break;
      case SanjeevaniEnum.Winthdraw:
        changeTab(1);
        break;
      case SanjeevaniEnum.FilterClick:
        setDashboardFilterOn(!dashboardFilterOn);
        break;
      case SanjeevaniEnum.SearchClick:
        setSearchText(event?.target?.value);
        break;
      //  case SanjeevaniEnum.ExportToExcelClick:
      // if (dataCount === 0) {
      //   notify(ToastType.Error, "No data available");
      // } else {
      //   if (
      //     tabs.find((tab) => tab.active && tab.id === "Deposite-requests")
      //   ) {
      //     ExportToExcelSSDash(
      //       getSNJYDepositRequestExportToExcel,
      //       appModule === AppModules.SuvidhaYojna
      //         ? "DepositSuvidhaReport_"
      //         : "DepositSanjeevaniReport_"
      //     );
      //   } else if (
      //     tabs.find((tab) => tab.active && tab.id === "Withdraw-requests")
      //   ) {
      //     ExportToExcelSSDash(
      //       GetSNJYWithdrawRequestExportToExcel,
      //       "WithdrawSanjeevaniReport_"
      //     );
      //   }
      // }
      // break;
      case SanjeevaniEnum.ExportToExcelClick:
        if (dataCount === 0) {
          notify(ToastType.Error, "No data available");
        } else {
          let exportUrl, fileNamePrefix;
          const activeTab = tabs.find((tab) => tab.active);
          if (activeTab) {
            switch (activeTab.id) {
              case "Deposite-requests":
                exportUrl =
                  appModule === AppModules.SuvidhaYojna
                    ? GetSUVYDepositRequestExportToExcel
                    : getSNJYDepositRequestExportToExcel;
                fileNamePrefix =
                  appModule === AppModules.SuvidhaYojna
                    ? "DepositSuvidhaReport_"
                    : "DepositSanjivaniReport_";
                break;
              case "Withdraw-requests":
                exportUrl =
                  appModule === AppModules.SuvidhaYojna
                    ? GetSUVYWithdrawRequestExportToExcel
                    : GetSNJYWithdrawRequestExportToExcel;
                fileNamePrefix = "WithdrawSanjivaniReport_";
                // appModule === AppModules.SuvidhaYojna
                //   ? "WithdrawSuvidhaReport_"
                //   : "WithdrawSanjivaniReport_";
                break;
              default:
                break;
            }
          }

          if (exportUrl && fileNamePrefix) {
            ExportToExcelSSDash(exportUrl, fileNamePrefix);
          }
        }
        break;
    }
  };

  const TabsComponent = ({ tab }) => {
    const { count, active, id, target, label } = tab;
    return (
      <StyledBadge
        badgeContent={count}
        color="error"
        className="mr-3"
        max={99}
        invisible={true}
      >
        <li className="nav-item" role="presentation">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            key="Dashboard"
            className={active ? "nav-link active" : "nav-link"}
            id={id}
            data-toggle="pill"
            role="tab"
            aria-controls="pills-MA"
            aria-selected={active ? "true" : "false"}
            onClick={() => handleEvents(target)}
          >
            {label}
          </a>
        </li>
      </StyledBadge>
    );
  };

  return (
    <>
      <div className="">
        <div className="clearfix"></div>
        <div className="page-content row filter-row-container m-0 no-gutters">
          <div className="transformer-tabs col-lg-12 col-md-12">
            <div className="meeting-tabs tabs-main col-lg-12 p-0">
              {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0"> */}
              <div className="col-lg-12 p-0">
                <div className="row">
                  <div className="col-lg-6 no-gutters">
                    <nav className="tabs mr-sm-4 --jsfied">
                      <ul
                        className="nav nav-pills  float-left with_tab"
                        id="pills-tab"
                        role="tablist"
                      >
                        {tabs.map((tab) => {
                          if (!tab.visible) return null;
                          return <TabsComponent tab={tab} key={tab.id} />;
                        })}
                      </ul>
                    </nav>
                  </div>
                  <div className="col-lg-6 d-flex justify-content-end no-gutters">
                    <div className="col-lg-6">
                      <div className="input-group">
                        {/*  Deposite-requests*/}
                        {tabs.find(
                          (tab) => tab.active && tab.id === "Deposite-requests"
                        ) && (
                          <input
                            className="form-control py-2 border-right-0 border"
                            type="Search"
                            value={searchText}
                            placeholder="Search"
                            onChange={(e) => setSearchText(e.target.value)}
                          />
                        )}

                        {/* Withdraw-requests */}
                        {tabs.find(
                          (tab) => tab.active && tab.id === "Withdraw-requests"
                        ) && (
                          <input
                            className="form-control py-2 border-right-0 border"
                            type="Search"
                            value={searchText}
                            placeholder="Search"
                            onChange={(e) => setSearchText(e.target.value)}
                          />
                        )}
                        <span className="input-group-append">
                          <div className="input-group-text bg-transparent">
                            <i className="fa fa-search"></i>
                          </div>
                        </span>
                      </div>
                    </div>
                    <Tooltip
                      title="Filters"
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                    >
                      <ButtonComponent
                        onClick={() => handleEvents(SanjeevaniEnum.FilterClick)}
                        className="btn btn-submit"
                        icon={"fa fa-filter"}
                        value=""
                      />
                    </Tooltip>

                    {/* Export to excel deposit*/}
                    {tabs.find(
                      (tab) => tab.active && tab.id === "Deposite-requests"
                    ) && (
                      <Tooltip
                        title="Deposit Export to excel"
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                      >
                        <button
                          className="btn btn-submit"
                          onClick={() => {
                            handleEvents(SanjeevaniEnum.ExportToExcelClick);
                          }}
                        >
                          <i className="fa fa-download"></i>
                        </button>
                      </Tooltip>
                    )}

                    {/* Export to excel withdraw*/}
                    {tabs.find(
                      (tab) => tab.active && tab.id === "Withdraw-requests"
                    ) && (
                      <Tooltip
                        title={
                          appModule === AppModules.SuvidhaYojna
                            ? "Deposit Export to excel"
                            : "Withdraw Export to excel"
                        }
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                      >
                        <button
                          className="btn btn-submit"
                          // onClick={WithdrawExportToExcel}
                          onClick={() => {
                            handleEvents(SanjeevaniEnum.ExportToExcelClick);
                          }}
                        >
                          <i className="fa fa-download"></i>
                        </button>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>

        <DepositeFilters
          activeTab={tabs.find((t) => t.active)}
          dashboardFilterOn={dashboardFilterOn}
          setCurrentFilters={setCurrentFilters}
          appModule={appModule}
        />

        <DepositeRequest
          searchText={searchText}
          setSearchText={setSearchText}
          activeTab={tabs.find((t) => t.active)}
          currentFilters={currentFilters}
          dataCount={dataCount}
          setDataCount={setDataCount}
          setCurrentDataReqObj={setCurrentDataReqObj}
          appModule={appModule}
          tab1={value2}
        />
      </div>
    </>
  );
};

export default SanjeevaniDashboard;
